// extracted by mini-css-extract-plugin
module.exports = {"container":"ServerData_container__xdw1g"};